import 'magnific-popup';

$('.js_popup_profile_picture').on('click', event => {
  event.preventDefault();
  createProfilePicturePopUp();
});

const createProfilePicturePopUp = () =>{
  $.ajax({
    url: '/popup_profile_picture',
    type: 'GET',
    success: (html) => {
      $('#popup_member_profile_picture').html(html);

      $.magnificPopup.open({
        items: {src: '#popup_profile_photo'},
        type: 'inline',
        fixedContentPos: true,
      }, 0);

      $(document).off('click.profilePicPopup', '.popup-btn-back')
                   .on('click.profilePicPopup', '.popup-btn-back', event => {
        event.preventDefault();
        $.magnificPopup.close();
      });
    },
    error: (error) => {
      console.error(error);
      alert('ポップアップの作成に失敗しました');
    }
  });
};
